import { cn } from '@/utils/tailwind';
import { VariantProps, cva } from 'class-variance-authority';

const badgeSquareVariants = cva('', {
  variants: {
    variant: {
      primary: 'text-point-500 bg-point-100',
      blue: 'text-blue-400 bg-blue-100',
      red: 'text-red-400 bg-red-100',
      green: 'text-green-400 bg-green-100',
      gr: 'text-gr-600 bg-gr-50',
      purple: 'text-point-500 bg-point-100',
      muted: 'text-gr-800 bg-gr-100',
    },
    size: {
      sm: 'px-[3px] py-[1px] rounded-[2px] Caption3M10',
      md: 'px-[6px] py-[2px] rounded-[4px] Caption2S12 ',
      plusBadge: 'px-[6px] py-[2px] rounded-[8px] Caption1M12',
      registerBadge: 'px-[8px] py-[4px] rounded-[8px] Body5M14',
    },
  },
});

const BadgeSquare = ({ className, variant, size, ...props }: BadgeSquareProps) => {
  return <div className={cn(badgeSquareVariants({ variant, size }), className)} {...props} />;
};

export type BadgeSquareProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeSquareVariants> & {
    size: 'sm' | 'md' | 'plusBadge' | 'registerBadge';
  };

export default BadgeSquare;
